import { KpiReadout } from "@/components/ui/kpi-readout";

interface QuickFitData {
  label: string;
  baseline_score: { value: number; metric: string };
  feature_importance: Array<{ feature: string; gain: number }>;
  task_type: string;
  train_rows: number;
  val_rows: number;
}

interface QuickFitVizProps {
  data: QuickFitData;
}

export function QuickFitViz({ data }: QuickFitVizProps) {
  if (!data?.feature_importance || !Array.isArray(data.feature_importance)) {
    return <p className="text-xs text-muted">No quick fit data available.</p>;
  }

  return (
    <div className="space-y-6">
      {/* KPI Strip */}
      <div className="grid grid-cols-4 gap-px rounded-[14px] border border-line bg-line overflow-hidden">
        <KpiReadout
          label="Baseline Score"
          value={data.baseline_score.value.toFixed(3)}
          suffix={data.baseline_score.metric}
        />
        <KpiReadout label="Task Type" value={data.task_type} />
        <KpiReadout label="Train Rows" value={data.train_rows.toLocaleString()} />
        <KpiReadout label="Val Rows" value={data.val_rows.toLocaleString()} />
      </div>

      {/* Feature Importance Table */}
      <div>
        <h3 className="mb-3 font-mono text-sm font-semibold text-navy-600 dark:text-zinc-300">
          Feature Importance
        </h3>
        <div className="overflow-hidden rounded-lg border border-line">
          <table className="w-full">
            <thead className="bg-surface">
              <tr>
                <th className="px-3 py-2 text-left font-mono text-[10px] font-semibold uppercase tracking-wider text-navy-300">
                  Feature
                </th>
                <th className="px-3 py-2 text-right font-mono text-[10px] font-semibold uppercase tracking-wider text-navy-300">
                  Gain
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line">
              {data.feature_importance.map((item) => (
                <tr key={item.feature} className="bg-surface hover:bg-surface-hover">
                  <td className="px-3 py-2 font-mono text-sm text-navy-700 dark:text-zinc-200">
                    {item.feature}
                  </td>
                  <td className="px-3 py-2 font-mono tabular-nums text-sm text-navy-700 dark:text-zinc-200 text-right">
                    {item.gain.toFixed(1)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
